<template>
  <div>
    <b-modal
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      dialog-class="monthly-new-user-contract-modal"
      v-model="modalShow"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title mr-2">{{ title }}</h5>

        <convert-excel
          class="btn btn-success"
          :data="excel_json.data"
          :fields="excel_json.fields"
          :table="excel_json.table"
          :worksheet="excel_json.worksheet"
          :name="excel_json.name"
          :type="excel_json.type"

        >
          匯出Excel
        </convert-excel>
        <!-- <convert-excel
          class="btn btn-success btn-sm"
          :data="excel_json.data"
          :fields="excel_json.fields"
          :worksheet="excel_json.worksheet"
          :name="excel_json.name"
          :type="excel_json.type"
        >
          下載
        </convert-excel> -->

        <button type="button" aria-label="Close" class="close" @click="close()">×</button>
      </template>

      <div class="container-fluid overflow-auto">
        <div class="operate">
          <b-form-select
            v-model="search.status"
            :options="options.status"
            @change="getMember(1)" />

          <b-form-checkbox
            class="mb-2"
            switch
            size="lg"
            value=1
            unchecked-value=0
            v-model.number="search.both_join"
            @change="getMember(1)"
          >
            同時加入A和B
          </b-form-checkbox>
        </div>

        <tables-page
          :tableData="table_data"
          :tableFields="table_fields"
          v-on:result="getMember"
        >
          <template #cell(status)="row">
            {{ getRightsInterests(row.item.status).text }}
          </template>

          <template #cell(join_date)="row">
            {{ convertRocDate(row.item.join_date, false) }}
          </template>

          <template #cell(seniority)="row">
            <template v-if="row.item.seniority_day >= 30">{{ row.item.seniority_month }}個月</template>

            <template v-else>{{ row.item.seniority_day }}天</template>
          </template>

          <template #cell(first_payment_at)="row">
            {{ convertRocDate(row.item.first_payment_at, false) }}
          </template>

          <template #cell(re_sales)="row">
            <template v-if="row.item.children.length > 0 && row.item.first_return === 1">{{ row.item.children[0].number }}</template>
          </template>

          <template #cell(re_name)="row">
            <template v-if="row.item.children.length > 0 && row.item.first_return === 1">{{ row.item.children[0].name }}</template>
          </template>
        </tables-page>
      </div>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import ConvertExcel from "@/components/common/ConvertExcel";
import contractApi from "@/models/API/contractApi";
import { convertRocDate, convertDateFormat, getFirstAndLastDayOfMonth, getRightsInterests, getTodayDate } from "@/models/HELPERS/common.js";

export default {
  name: 'MonthlyNewUserContractModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
    isDateRange: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  components: {
    TablesPage,
    ConvertExcel
  },
  data () {
    return {
      status: {
        isLoading: false
      },
      options: {
        status: [
          { value: '', text: '全部' },
          { value: 0, text: '正常' },
          { value: 1, text: '身故' },
          { value: 2, text: '停效' },
          { value: 3, text: '除會' },
          { value: 4, text: '墊繳' },
        ],
      },
      search: {
        status: '',
        both_join: 0
      },
      table_fields: [
        {
          key: "no",
          label: "No"
        },
        {
            key: "plan",
            label: "組別",
            sortable: true
        },
        {
            key: "status",
            label: "權益",
            sortable: true
        },
        {
          key: "sales_number",
          label: "業務編號",
          sortable: true
        },
        {
          key: "sales_name",
          label: "業務姓名",
          sortable: true
        },
        {
          key: "number",
          label: "契約編號",
          sortable: true
        },
        {
          key: "join_date",
          label: "入會日期",
          sortable: true
        },
        {
          key: "member_ID_number",
          label: "互助人身分證",
          sortable: true
        },
        {
          key: "member_name",
          label: "互助人",
          sortable: true
        },
        {
          key: "pay_name",
          label: "要助人",
          sortable: true
        },
        {
          key: "beneficiary_name",
          label: "受款人",
          sortable: true
        },
        {
          key: "seniority",
          label: "年資"
        },
        {
          key: "sales_reserve",
          label: "儲總姓名"
        },
        {
          key: "sales_director",
          label: "總監姓名"
        },
        {
          key: "first_payment_at",
          label: "次月繳款日"
        },
        {
          key: "re_sales",
          label: "上歸業務"
        },
        {
          key: "re_name",
          label: "上歸姓名"
        },
        {
          key: "servicer",
          label: "愛心天使站服務人"
        }
      ],
      table_data: [],
      page: {},
      table_sort: {
        sortBy: '',
        sort: ''
      },
      // excel_json: {
      //   fields: {},
      //   data: [],
      //   worksheet: 'My Worksheet',
      //   name: '每組每月慰問金統計.csv',
      //   type: 'csv'
      // },
      excel_json: {
        fields: {},
        data: [],
        table: '',
        worksheet: 'My Worksheet',
        name: '每月新增人數.xls',
        type: 'table'
      }
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    title() {
      let text = '';

      if (this.isDateRange) {
        text = `${this.data.date_S} ~ ${this.data.date_E}入會的會員`
      } else {
        text = `${Number(this.data.month.split('-')[0]) - 1911}-${Number(this.data.month.split('-')[1])}入會的會員`
      }

      return text;
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.search.both_join = 0;

          this.getMember();
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.page = Object.assign({}, this.contractApi.page);
    },
    convertRocDate,
    getRightsInterests,
    // 查詢契約
    getMember(pageIndex = null, sortBy = '', sort = '') {
      this.status.isLoading = true;

      if (sortBy) this.table_sort.sortBy = sortBy;
      if (sort) this.table_sort.sort = sort;

      const join_date_S = this.isDateRange ? getFirstAndLastDayOfMonth(`${this.data.date_S}-01`, false, true).first_day : getFirstAndLastDayOfMonth(`${this.data.month}-01`).first_day;
      const join_date_E = this.isDateRange ? getFirstAndLastDayOfMonth(`${this.data.date_E}-01`, false, true).last_day : getFirstAndLastDayOfMonth(`${this.data.month}-01`).last_day;
      const params = {
        ...this.search,
        'join_date_S': join_date_S,
        'join_date_E': join_date_E,
        'sortBy': this.table_sort.sortBy,
        'sort': this.table_sort.sort,
      };

      this.contractApi.getMember((response) => {
        const res = response.data;

        this.table_data = res.data.map((item, index) => {
          return {
            ...item,
            no: index + 1
          }
        });

        this.initCsvData();

        this.status.isLoading = false;
      }, params, false)
    },
    // 初始化csv資料
    initCsvData() {
      return new Promise(async(resolve, reject) => {
      let fields = {}, data = [];
      const join_date_S = this.isDateRange ? getFirstAndLastDayOfMonth(`${this.data.date_S}-01`, false, true).first_day : getFirstAndLastDayOfMonth(`${this.data.month}-01`).first_day;
      const join_date_E = this.isDateRange ? getFirstAndLastDayOfMonth(`${this.data.date_E}-01`, false, true).last_day : getFirstAndLastDayOfMonth(`${this.data.month}-01`).last_day;
      let thead = `<thead>
                      <tr>
                        <th colspan="3">每月新增人數</th>
                        <th align="left" colspan="3">日期：${join_date_S} ~ ${join_date_E}</th>
                        <th colspan="4"></th>
                        <th colspan="2">製表日：${getTodayDate(true)}</th>
                      </tr>
                      <tr>
                    `,
          tbody = '<tbody>';

      this.table_fields.forEach(fields_item => {
        thead += `<th >${fields_item.label}</th>`;
      })

      thead += '</tr></thead>';

      this.table_data.forEach((item, index) => {
        tbody += '<tr>';

        this.table_fields.forEach(value => {
          if (value.key === 'join_date' || value.key === 'first_payment_at') {
            tbody += `<td style="mso-number-format:\'yyyy-mm-dd\'">${item[value.key] !== null ? item[value.key] : ''}</td>`;
          } else if (value.key === 'status') {
            tbody += `<td>${getRightsInterests(item[value.key]).text}</td>`;
          } else if (value.key === 're_sales') {
            tbody += `<td>${item.children.length > 0 && item.first_return === 1 ? item.children[0].number : ''}</td>`;
          } else if (value.key === 're_name') {
            tbody += `<td>${item.children.length > 0 && item.first_return === 1 ? item.children[0].name : ''}</td>`;
          } else if (value.key === 'seniority') {
            const show_month = item.seniority_day >= 30;

            tbody += `<td>${show_month ? `${item.seniority_month}個月` : `${item.seniority_day}天`}</td>`;
          } else {
            tbody += `<td>${item[value.key] !== null ? item[value.key] : ''}</td>`;
          }
        })

        tbody += '</tr>';
      })

        tbody += '</tbody>';

      // this.table_fields.forEach(fields_item => {
      //   fields = {
      //     ...fields,
      //     [fields_item.label]: fields_item.key
      //   }
      // })

      // this.table_data.forEach(data_item => {
      //   let temp_data = {};

      //   this.table_fields.forEach(fields_item => {
      //     if (fields_item.key === 'join_date') {
      //       temp_data = {
      //         ...temp_data,
      //         [fields_item.key]: data_item[fields_item.key] ? convertDateFormat(data_item[fields_item.key], false) : ''
      //       }
      //     } else if (fields_item.key === 'status') {
      //       temp_data = {
      //         ...temp_data,
        //         [fields_item.key]: getRightsInterests(data_item[fields_item.key]).text
        //       }
        //     } else if (fields_item.key === 'seniority') {
        //       const show_month = data_item.seniority_day >= 30;

        //       temp_data = {
        //         ...temp_data,
        //         [fields_item.key]: show_month ? `${data_item.seniority_month}個月` : `${data_item.seniority_day}天`
        //       }
        //     } else {
        //       temp_data = {
        //       ...temp_data,
        //         [fields_item.key]: data_item[fields_item.key] !== null ? data_item[fields_item.key] : ''
        //       }
        //     }
        //   })

        //   data.push(temp_data)
        // })

        this.excel_json.table = thead + tbody;

         resolve(true);
        // this.excel_json.fields = fields;
        // this.excel_json.data = data;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .monthly-new-user-contract-modal {
  max-width: 1440px !important;
  .operate {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/MonthlyNewUserContractModal.vue